module.exports = __webpack_public_path__ + "static/media/active-random.98830423.svg";